import { Separator } from 'components/ui/separator';

/** A short vertical rule between inline groups; hidden below the `sm` breakpoint. */
export default function VerticalDivider() {
    return (
        <Separator
            orientation="vertical"
            className="bg-grey-400 mx-3 hidden h-3.5 data-vertical:self-center sm:block"
        />
    );
}
